import {
  Box,
  Container,
  RowContainer,
  SearchBar,
  SearchInput,
} from './SearchBox.styles';
import * as React from 'react';

export interface SearchBoxProps {
  placeholder?: string;
  columnHeaders: React.ReactNode;
  rows: React.ReactNode;
  testLabel?: string;
  searchUsers: (searchTerm: string) => void;
  visible: boolean;
}

export const SearchBox = ({
  placeholder,
  columnHeaders,
  rows,
  testLabel,
  searchUsers,
  visible,
}: SearchBoxProps) => {
  const ref = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    if (ref.current) {
      ref.current.value = '';
    }
  }, [visible]);
  return (
    <Container>
      <Box>
        <SearchBar>
          <SearchInput
            data-testid={`search-bar-input/${testLabel ?? 'empty'}`}
            placeholder={placeholder ?? 'Search'}
            onChange={(event) => searchUsers(event.target.value)}
            ref={ref}
          />
          <img alt="" src="/assets/manualIntake/search.svg" />
        </SearchBar>
      </Box>
      {columnHeaders}
      <RowContainer>{rows}</RowContainer>
    </Container>
  );
};
